<template>
  <div id="app">
    <!-- 修复：补充闭合引号和括号 -->
    <AppHeader v-if="!$route.meta.hideHeader" :isScrolled="isScrolled" :hiddenLogo="!$route.meta.hiddenLogo" />
    <transition name="el-fade-in-linear">
      <router-view :key="routerKey" />
    </transition>
  </div>
</template>

<script>
import AppHeader from './components/header.vue';

function throttle(fn, delay = 100) {
  let timer = null;
  return function() {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
      }, delay);
    }
  };
}

export default {
  name: 'App',
  components: {
    AppHeader
  },
  data() {
    return {
      routerKey: Date.now(),
      isScrolled: false
    };
  },
  mounted() {
    this.throttledHandleScroll = throttle(this.handleScroll, 200);
    window.addEventListener('scroll', this.throttledHandleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttledHandleScroll);
  },
  methods: {
    refreshPage() {
      // 只需修改key的值（新时间戳），路由视图就会重新渲染
      this.routerKey = Date.now();
    },
    handleScroll() {
      // 兼容各浏览器的滚动距离获取
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isScrolled = scrollTop > 0;
    }
  }
};
</script>
<style>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 统一盒模型计算方式 */
}
</style>